export const formatPhoneNumber = (phoneNumber) => {
  const match = phoneNumber.match(/^(\d{3})(\d{3})(\d{0,4})$/);

  if (match) {
    const areaCode = match[1];
    const firstPart = match[2];
    const lastPart = match[3];

    if (lastPart.length === 0) {
      return `+1 (${areaCode}) ${firstPart}`;
    } else {
      return `+1 (${areaCode}) ${firstPart}-${lastPart}`;
    }
  } else {
    return phoneNumber;
  }
};
